import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { LicenseInfo } from "@mui/x-license-pro";
import { setupI18n } from "@acto/web-common/locales";
import { createManagementRouter } from "./router";

import "./styles.css";
import translationEnUS from "./locales/en-US.json";
import translationDeDE from "./locales/de-DE.json";

console.debug("[acto] management-app build:", import.meta.env.VITE_BUILD_VERSION ?? "local");

LicenseInfo.setLicenseKey(import.meta.env.VITE_MATERIAL_UI_LICENSE_KEY);

async function bootstrap() {
  await setupI18n({ translationDeDE, translationEnUS });

  const router = createManagementRouter();

  const rootElement = document.getElementById("root");
  if (!rootElement) throw new Error("Root element not found");

  createRoot(rootElement).render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  );
}

void bootstrap();
